import * as React from 'react';
import { createRoot } from 'react-dom/client';
import TextField from '@mui/material/TextField';

export default function editorTextarea(cell, onRendered, success, cancel, editorParams){
  const editor = document.createElement("div");
  editor.style.width = "100%";
  editor.style.height = "100%";
  const styleBorder = cell.getElement().style.border
  cell.getElement().style.border = 'none';

  const root = createRoot(editor);

  const bs4Success = (value) => {    
    cell.getElement().style.border = styleBorder;
    root.unmount()
    success(value);
  }

  onRendered(() => {
    if(cell._getSelf){
      root.render(
        <ViewComponentTextarea
          value={cell.getValue()} 
          bs4Success={bs4Success}
          cancel={cancel}
          cell={cell}
          editor={editor}
        />
      );      
    }
  });
  
  return editor;
}

const ViewComponentTextarea = (props) => {
  const [value, setValue] = React.useState(props.value);
  const refResize = React.useRef(null);
  const inputRef = React.useRef(null);
  const awayRef = React.useRef({mouseTextField: true, height: 0});

  const handleChange = (event) => {
    setValue(event.target.value)
    const react = refResize.current.getBoundingClientRect();
    if (awayRef.current.height !== react.height) {
      props.cell.getRow().normalizeHeight();
      awayRef.current.height = react.height;      
    }
  }

  const onBlurTextField = (e) => {
    if (awayRef.current.mouseTextField) {
      props.bs4Success(value);
    }
    e.stopPropagation();
  }

  React.useEffect(() => {
    props.cell.getRow().normalizeHeight();
    const length = inputRef.current?.value?.length;
    if (length) inputRef.current.setSelectionRange(length, length);
  }, [props.cell])

  const onKeyDownTextField = (e) => {
    switch(e.keyCode){
      case 13: //Enter
        break;

      case 9: //Tab
        awayRef.current.mouseTextField = true
        break;

      case 27:  //Esc
        props.cancel();
        break;

      case 38: //up arrow
        if (inputRef.current?.selectionStart > 0) {
          e.stopPropagation();
        } else {
          awayRef.current.mouseTextField = true
        }
        break;
      case 40: //down arrow
        const length = inputRef.current?.value?.length;
        if (inputRef.current?.selectionStart < length) {
          e.stopPropagation();
        } else {
          awayRef.current.mouseTextField = true
        }
        break;

      case 35:
      case 36:
        e.stopPropagation();
        break;

      default:
        break;
    }
  }  
    
  React.useEffect(() => {
    // !!! resizeobserver loop limit exceeded at ...
    let resizeObserverTimeout = null;
    const resizeObserver = new ResizeObserver((e) => {
      clearTimeout(resizeObserverTimeout);
      resizeObserverTimeout = setTimeout(() => {
        props.cell.getRow().normalizeHeight();
      }, 50);
    });
    resizeObserver.observe(refResize.current);

    return () => {
      resizeObserver.disconnect();
    }
  }, [props.cell]);
  
  return (
    <TextField 
      ref={refResize}
      inputRef={inputRef}
      fullWidth
      multiline          
      InputLabelProps={{sx:{display:'none'}}}
      InputProps={{sx: {color: 'inherit', fontSize: 'inherit', fontWeight: 'inherit'}}}
      value={value}
      onChange={handleChange}
      autoComplete='off'
      onBlur={onBlurTextField}
      onMouseEnter={(e) => awayRef.current.mouseTextField = false}
      onMouseLeave={(e) => awayRef.current.mouseTextField = true}
      onKeyDown={onKeyDownTextField}
      autoFocus
      margin='dense'            
      size="small"
      variant='outlined'
      sx={{mt:'1px', mb:'1px', my:'1px'}}
    />   
  );
}
